module.exports = __webpack_public_path__ + "img/brand-12.47b482b4.png";